import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: 'app-alternate-vsa-dialog',
  templateUrl: './alternate-vsa-dialog.component.html',
  styleUrls: ['./alternate-vsa-dialog.component.scss']
})
export class AlternateVsaDialogComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
  }

  viewPDF() {
    window.open('/assets/pdf/tfs-advance-as-of-january-2024.pdf', '_blank');
  }

}
